/**
 * Created by filatov on 19.08.2015.
 */
import TableTooltip from './TableTooltip'
import {calculateTooltipOffset} from '../atBrowserUtils'
import $ from "jquery"

export default function ChooseTypeSelector(){}

ChooseTypeSelector.prototype.init = function(dateRangeType, changeCallback){
    var self = this;
    this.checkBoxTypeComletedTasks = $("#type_completed_tasks");
    this.checkBoxTypeTimeReported = $("#type_time_reported");
    this.checkBoxTypeComletedTasks.on("click", function(){self.updateReportTypeSection()});
    this.checkBoxTypeTimeReported.on("click", function(){self.updateReportTypeSection()});
    this.checkBoxTypeComletedTasks.on("change", changeCallback);
    this.checkBoxTypeTimeReported.on("change", changeCallback);


    this.timeReportedSection = $("#type_time_reported_section");
    this.timeCompletedSection = $("#type_completed_tasks_section");
    this.allTimeReportedTooltip = new TableTooltip().init("all_time_reported_tooltip");
    this.completedTaskReportedTooltip = new TableTooltip().init("completed_tasks_tooltip");

    this.timeReportedSection.hover( 
            function ( event ) { 
                /*do nothing on hover only on mousemove see bug 52931, 
                also hooking "show tooltip" function on different events is not a good idea*/ 
            },
            function () { self.hideTooltip(self.allTimeReportedTooltip); } );
    this.timeReportedSection.mousemove( function ( event ) {self.moveTooltip(self.allTimeReportedTooltip, event ) } );

    this.timeCompletedSection.hover( function ( event ) { /*do nothing on hover only on mousemove*/ },
                                     function () { self.hideTooltip(self.completedTaskReportedTooltip); } );
    this.timeCompletedSection.mousemove( function ( event ) {self.moveTooltip(self.completedTaskReportedTooltip, event ) } );

    this.setValue(dateRangeType);
    this.updateReportTypeSection();


    return this;
};


ChooseTypeSelector.prototype.updateReportTypeSection = function()
{
    if(  this.checkBoxTypeTimeReported.is(":checked" ))
    {
        this.turnOnSection(  this.timeReportedSection );
        this.turnOffSection(  this.timeCompletedSection );
    }

    if( this.checkBoxTypeComletedTasks.is(":checked") )
    {
        this.turnOnSection( this.timeCompletedSection );
        this.turnOffSection( this.timeReportedSection );
    }
};

ChooseTypeSelector.prototype.setValue = function(value){
    $("input[name=dateRangeType][value=" +value+"]" ).prop('checked', true);
    this.updateReportTypeSection();
};

ChooseTypeSelector.prototype.getValue = function(){
    return $("input[type='radio'][name='dateRangeType']:checked").val();
};

ChooseTypeSelector.prototype.turnOnSection = function( section )
{
    section.removeClass("sectionedRadio_unchecked");
    section.addClass("sectionedRadio_checked");
};

ChooseTypeSelector.prototype.turnOffSection = function( section )
{
    section.removeClass("sectionedRadio_checked");
    section.addClass("sectionedRadio_unchecked");
};

ChooseTypeSelector.prototype.showTooltip = function(tooltip, event)
{
   tooltip.timeout = setTimeout(function(){tooltip.isShow = true; tooltip.show(); tooltip.move(calculateTooltipOffset( tooltip, event )); },1000);
};

ChooseTypeSelector.prototype.moveTooltip = function(tooltip, event)
{
    if (tooltip.timeout) clearTimeout( tooltip.timeout);
    if(!tooltip.isShow){
        this.showTooltip(tooltip, event);
    }
    tooltip.move(calculateTooltipOffset( tooltip, event ) );
};

ChooseTypeSelector.prototype.hideTooltip = function(tooltip)
{
    if(tooltip.timeout) clearTimeout(tooltip.timeout);
    tooltip.isShow = false;
    tooltip.hide();
};


// WEBPACK FOOTER //
// ./web/js/controls/invoice_billing_summary_choose_type.js